import { render } from "./HeroSlider.vue?vue&type=template&id=0009f7a0&scoped=true"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"

import "./HeroSlider.vue?vue&type=style&index=0&id=0009f7a0&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Asistenca\\old-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0009f7a0"]])

export default __exports__